import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/homepage";
import WaitListLandingPage from "./pages/waitlistlandingpage";
import UnsubscribePage from "./pages/unsubscribepage"; 
import PrivacyPage from "./pages/privacypage"; 
import AboutPage from "./pages/aboutpage"; 
import AGBPage from "./pages/agbpage"; 
import NewsletterLandingPage from "./pages/newsletterlandingpage";
import Impressum from "./pages/impressumpage";  
import AppRedirect from "./pages/storepage";
import RecipePage from "./pages/recipepage";  
import RouteSeo from "./components/routeseo";
import CookieConsent from "./components/cookiepopup";
import { Analytics } from "@vercel/analytics/react"

export default function App() {
  return (
    <Router>
      <RouteSeo />
      <Analytics/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/waitlist" element={<WaitListLandingPage />} />
        <Route path="/unsubscribe" element={<UnsubscribePage />} /> 
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/agb" element={<AGBPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/newsletter" element={<NewsletterLandingPage />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/store" element={<AppRedirect />} />
        <Route path="/recipe" element={<RecipePage />} />
      </Routes>
      <CookieConsent />
    </Router>
  );
}
